import React, { useState, useEffect } from "react";
import "./formCultureAttribute.css";
import { Form, Input, Button, Typography, Space, Row, Col, Select, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import DraggableBehaviors from "../draggableBehaviors/DraggableBehaviors";
import OrderingAPI from "../../utils/OrderingAPI";

const { Text, Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const FormCultureAttribute = (props) => {
    const [isEditing, setIsEditing] = useState(false);

    // Opciones para el tipo de atributo cultural
    const cultureTypeOptions = [
        { value: "Atributo de Cultura", label: "Atributo de Cultura" },
        { value: "Palancas culturales", label: "Palancas culturales" },
        { value: "Compromiso", label: "Compromiso" }
    ];

    // Funciones de edición y guardado
    const handleEditClick = () => setIsEditing(true);
    const handleSaveClick = () => {
        setIsEditing(false);
        props.saveCultureAttribute();
    };

    const handleCreateClick = () => {
        props.createCultureAttribute();
    };

    useEffect(() => {
        setIsEditing(false);
    }, [props.catId]);

    const handleBehaviorChange = (index, value) => {
        // ✅ Clonar el array de behaviors sin modificar el original
        const updatedBehaviors = [...(props.catBehaviors || [])];
        if (updatedBehaviors[index]) {
            updatedBehaviors[index] = { ...updatedBehaviors[index], cab_behavior: value };
        } else {
            updatedBehaviors[index] = { cab_id: null, cab_behavior: value };
        }
        props.setCatBehaviors(updatedBehaviors);
    };

    const addBehavior = () => {
        const updatedBehaviors = [...(props.catBehaviors || [])];
        updatedBehaviors.push({ cab_id: null, cab_behavior: "" });
        props.setCatBehaviors(updatedBehaviors);
    };

    const removeBehavior = (index) => {
        const updatedBehaviors = (props.catBehaviors || []).filter((_, i) => i !== index);
        props.setCatBehaviors(updatedBehaviors);
    };

    const handleBehaviorOrderChange = (orderData) => {
        // Esta función maneja el cambio de orden temporal sin guardar
        console.log('Orden temporal cambiado:', orderData);
    };

    const handleSaveBehaviorOrder = async (orderData) => {
        try {
            // Hacer llamada API para actualizar el orden usando OrderingAPI
            const response = await OrderingAPI.updateCultureBehaviorsOrder(orderData);

            if (response.success) {
                console.log('Orden guardado exitosamente');
                // Opcionalmente mostrar mensaje de éxito
            }
        } catch (error) {
            console.error('Error al guardar orden:', error);
        }
    };

    // Convertir behaviors para el componente DraggableBehaviors
    const getBehaviorTexts = () => {
        return (props.catBehaviors || []).map(behavior => behavior.cab_behavior || '');
    };

    // Pasar behaviors completos con IDs
    const getBehaviorsWithIds = () => {
        return (props.catBehaviors || []);
    };

    return (
        <Form layout="horizontal">
            {/* Nombre del atributo cultural */}
            <Row align="middle" style={{ marginBottom: 10 }}>
                <Col span={4}><Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Nombre:</Text></Col>
                <Col span={20}>
                    {isEditing || props.newCultureAttribute ? (
                        <Input 
                            value={props.catAttribute} 
                            onChange={(e) => props.setCatAttribute(e.target.value)} 
                        />
                    ) : (
                        <Text>{props.catAttribute || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Descripción del atributo cultural */}
            <Row align="middle" style={{ marginBottom: 10 }}>
                <Col span={4}><Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Descripción:</Text></Col>
                <Col span={20}>
                    {isEditing || props.newCultureAttribute ? (
                        <Input 
                            value={props.catDescription} 
                            onChange={(e) => props.setCatDescription(e.target.value)} 
                        />
                    ) : (
                        <Text>{props.catDescription || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Tipo de atributo cultural */}
            <Row align="middle" style={{ marginBottom: 10 }}>
                <Col span={4}><Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Tipo:</Text></Col>
                <Col span={20}>
                    {isEditing || props.newCultureAttribute ? (
                        <Select
                            value={props.catType}
                            onChange={(value) => props.setCatType(value)}
                            style={{ width: "100%" }}
                            placeholder="Selecciona el tipo de atributo"
                        >
                            {cultureTypeOptions.map(option => (
                                <Option key={option.value} value={option.value}>
                                    {option.label}
                                </Option>
                            ))}
                        </Select>
                    ) : (
                        <Text>{props.catType || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Comportamientos del atributo */}
            <Row style={{ marginBottom: 10 }}>
                <Col span={4}><Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Comportamientos:</Text></Col>
                <Col span={20} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {!props.newCultureAttribute && props.catId && (props.catBehaviors || []).length > 0 && props.onDeleteAllBehaviors && (
                        <Popconfirm
                            title="¿Eliminar todos los comportamientos?"
                            description="Esta acción eliminará todos los comportamientos de este atributo. No se puede deshacer."
                            onConfirm={() => props.onDeleteAllBehaviors(props.catId)}
                            okText="Sí, eliminar"
                            cancelText="Cancelar"
                            okButtonProps={{ danger: true }}
                        >
                            <Button danger size="small" icon={<DeleteOutlined />}>
                                Eliminar todos los comportamientos ({(props.catBehaviors || []).length})
                            </Button>
                        </Popconfirm>
                    )}
                </Col>
            </Row>
            
            <DraggableBehaviors
                behaviors={getBehaviorsWithIds()}
                isEditing={isEditing || props.newCultureAttribute}
                onBehaviorChange={handleBehaviorChange}
                onBehaviorAdd={addBehavior}
                onBehaviorDelete={removeBehavior}
                onOrderChange={handleBehaviorOrderChange}
                onSaveOrder={handleSaveBehaviorOrder}
                attributeId={props.catId}
                attributeType="culture"
            />

            {/* Botones */}
            <Row justify="end" style={{ marginTop: 20 }}>
                <Space>
                    {props.newCultureAttribute ? (
                        <Button type="primary" onClick={handleCreateClick}>Guardar</Button>
                    ) : isEditing ? (
                        <>
                            <Button type="primary" onClick={handleSaveClick}>Guardar</Button>
                            <Button onClick={() => setIsEditing(false)}>Cancelar</Button>
                        </>
                    ) : (
                        <Button type="default" onClick={handleEditClick}>Editar</Button>
                    )}
                </Space>
            </Row>
        </Form>
    );
};

export default FormCultureAttribute;